module.exports = __webpack_public_path__ + "img/logo_black.4b6cef56.png";